import { z } from 'zod';
import { BaseValidatorSchema } from '../base-validator-schema';

export const MaximumValidator = z.literal('maximum');
export type TMaximumValidator = z.infer<typeof MaximumValidator>;

export const MaximumValidatorParamsSchema = z.object({
  maximum: z.number(),
});

export type TMaximumValidatorParams = z.infer<typeof MaximumValidatorParamsSchema>;

export const MaximumValidatorSchema = BaseValidatorSchema.extend({
  type: MaximumValidator,
  value: MaximumValidatorParamsSchema,
});
